import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  catalogueIdUpdated,
  filtersUpdated,
  releaseStatusUpdated,
  selectedSPWUpdated,
  spwFilterUrlUpdated,
} from "../../redux/reducer";
import { useGetCatalogueDataByIdQuery, useGetCatalogueReleaseStatusQuery } from "../../redux/catalogueService";
import { breadcrumbNodesUpdated } from "../../redux/reducer";
import "./Catalogue.scss";
import { BASE_BREADCRUMB_NODE, CATALOGUE_NODE } from "../../constants";
import { AppContext } from "../../context/appContext";
import Authorization from "../Authorization/Authorization";
import ReleaseCatalogue from "../ReleaseCatalogue/ReleaseCatalogue";
import CatalogueDataSection from "../CatalogueDataSection/CatalogueDataSection";
import { isEmptyString } from "../../helperFunc";


function Catalogue() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { catalogueMetadataId } = useParams();
  const [isReleased, setIsReleased] = useState(null);
  const { toggleLoaderVisibility } = useContext(AppContext);
  const { selectedSPW } = useSelector((state) => state.router);
  let {data:releaseStatusData} = useGetCatalogueReleaseStatusQuery(catalogueMetadataId);

  useEffect(() => {
    dispatch(
      breadcrumbNodesUpdated({
        breadcrumbNodes: [...BASE_BREADCRUMB_NODE, ...CATALOGUE_NODE],
      })
    );
    dispatch(catalogueIdUpdated({ catalogueId: catalogueMetadataId }));
    let spwFilterUrlValues = {
      base_url: "catalogues",
      id: catalogueMetadataId,
    };
    dispatch(spwFilterUrlUpdated({ spwFilterUrl: spwFilterUrlValues }));
  }, []);

  useEffect(()=>{
    dispatch(releaseStatusUpdated({
      releaseStatus:releaseStatusData?.releaseStatus?.status
    }))
  },[releaseStatusData])

  let { currentData, isFetching } = useGetCatalogueDataByIdQuery(
    {
      id: catalogueMetadataId,
      spw:
        isEmptyString(selectedSPW) || selectedSPW === "ALL"
          ? null
          : selectedSPW,
    },
    {
      skip: isEmptyString(selectedSPW),
    }
  );

  useEffect(() => {
    if (isFetching) {
      toggleLoaderVisibility(true);
    } else {
      toggleLoaderVisibility(false);
    }
  }, [isFetching]);

  function navigateSourceTo(urlId) {
    navigate(`../${urlId}`, {
      state: { internalNavigation: true },
    });
    dispatch(filtersUpdated({ filters: {} }));
    dispatch(selectedSPWUpdated({ selectedSPW: "" }));
    let spwFilterUrlValues = { base_url: "pointing", id: urlId.split("/")[3], catalogue_id: urlId.split("/")[1] };
    dispatch(spwFilterUrlUpdated({ spwFilterUrl: spwFilterUrlValues }));
  }

  const setReleased = (val) => {
    setIsReleased(val);
  };

  const CatalogueDisplay = () => {
    if (isReleased === null) return;
    return isReleased ? (
      <></>
    ) : (
      <CatalogueDataSection
        data={currentData}
        navigateSourceTo={navigateSourceTo}
      />
    );
  };

  return (
    <>
      <Authorization>
        {
        <ReleaseCatalogue
          isExpanded={true}
          catalogueId={catalogueMetadataId}
          setIsReleased={setReleased}
        />}
      </Authorization>
      {CatalogueDisplay()}
    </>
  );
}

Catalogue.propTypes = {};

export default Catalogue;
